const SettingsAudio = () => <>hello world!</>;

export default SettingsAudio;
